export default "__VITE_ASSET__uMKcXXVU__"